export const AgreeTermAndConditions=(agreeTermCond) => {
    return {
      type:"Term_And_Conditions",
      agreeTermCond,
      segmentName: "TermAndConditions",
    }
}